import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { FIN_HELPER_API_BASE } from '../config';

const STORAGE_KEY = 'moneta_fin_helper_auth';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        const { access } = JSON.parse(stored);
        setToken(access);
      }
    } finally {
      setLoading(false);
    }
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await axios.post(`${FIN_HELPER_API_BASE}/auth/knock-knock/`, {
      email: email,
      password,
    });
    const { access, refresh } = data;
    setToken(access);
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ access, refresh }));
    return data;
  }, []);

  const logout = useCallback(() => {
    setToken(null);
    localStorage.removeItem(STORAGE_KEY);
  }, []);

  const value = { token, loading, login, logout, isAuthenticated: !!token };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
